import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";

import CancelIcon from "@mui/icons-material/Cancel";
import "../App.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Autocomplete from "./Autocomplete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useAppDispatch, useAppSelector } from "../Redux/store/hooks";
import { list_AlgoList } from "../Redux/Reducers/Algo-api/list_AlgoList_slicer";
import { list_StrategiesList } from "../Redux/Reducers/Strategies_api/list_StrategiesList_slicer";
import { edit_Selectvalue } from "../Redux/Reducers/Strategies_api/selectvalue";
import { useState } from "react";

type Anchor = "top" | "left" | "bottom" | "right";

export default function Mapfilter(props: any) {
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };

  const dispatcher = useAppDispatch();

  // filter the aglo name

  const data = useAppSelector((state) => state?.AlgoList?.data);
  const filterValue: any = useAppSelector((state) => state?.Selectvalue?.data);
  React.useEffect(() => {
    dispatcher(list_AlgoList(""));
  }, [dispatcher]);
  const defaultOption1 = { name: "All", id: null };

  const addto = [defaultOption1, ...data];

  return (
    <div>
      {(["right"] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <FilterListIcon
            onClick={toggleDrawer(anchor, true)}
            sx={{
              marginTop: "5px",
              fontSize: "24px",
              marginRight: "5px",
              marginLeft: "10px",
              cursor: "pointer",
            }}
          ></FilterListIcon>

          <Drawer anchor={anchor} open={state[anchor]}>
            <Box
              sx={{
                width: {
                  xs: 200,
                  sm: 200,
                  md: 300,
                  lg: 360,
                  xl: 400,
                },
                zIndex: "1",
              }}
              role="presentation"
            >
              <div
                style={{
                  display: "flex",
                  backgroundColor: "#2C8E14",
                  justifyContent: "space-between",
                  height: "64px",
                }}
              >
                <span
                  style={{
                    padding: "17px",
                    fontSize: "20px",
                    color: "white",
                    fontFamily: "Roboto",
                  }}
                >
                  Filter
                </span>
                <div style={{ padding: "20px", cursor: "pointer" }}>
                  <CancelIcon
                    sx={{ color: "white" }}
                    onClick={toggleDrawer(anchor, false)}
                  ></CancelIcon>
                </div>
              </div>
              <Formik
                initialValues={{
                  is_enabled: filterValue?.is_enabled ?? null, // Set the initial value here
                  algo_id: filterValue?.algo_id ?? null,
                }}
                validationSchema={Yup.object().shape({})}
                onSubmit={(values) => {
                  dispatcher(list_StrategiesList(values));
                  dispatcher(edit_Selectvalue(values));
                }}
              >
                {({
                  values,
                  errors,

                  touched,
                  handleSubmit,
                  handleBlur,
                  setFieldValue,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <div
                      style={{
                        color: "#000000",
                        fontSize: "14px",
                        padding: "10px 0px 0px 20px",
                        fontFamily: "Roboto",
                      }}
                    >
                      Select Status
                    </div>
                    <Autocomplete
                      Listitem={[
                        { label: "All", value: null },
                        { label: "Active", value: true },
                        { label: "Inactive", value: false },
                      ]}
                      variant={"outlined"}
                      name={"is_enabled"}
                      value={values}
                      onBlur={handleBlur}
                      onchange={(e: any) => {
                        setFieldValue("is_enabled", e.value);
                      }}
                      style={{
                        padding: "5px 20px 0px 20px ",
                        width: "100%",
                      }}
                      error={errors.is_enabled && touched.is_enabled}
                    ></Autocomplete>

                    <div
                      style={{
                        color: "#000000",
                        padding: "10px 0px 0px 20px",
                        fontSize: "14px",
                        fontFamily: "Roboto",
                      }}
                    >
                      Select Algo
                    </div>
                    <Autocomplete
                      Listitem={addto.map((v: any) => {
                        return {
                          label: v.name,
                          value: v.id,
                        };
                      })}
                      variant={"outlined"}
                      name={"algo_id"}
                      value={values}
                      onBlur={handleBlur}
                      onchange={(e: any, newValue: any) => {
                        setFieldValue("algo_id", e.value);
                      }}
                      style={{
                        padding: "5px 20px 0px 20px ",
                        width: "100%",
                      }}
                    ></Autocomplete>

                    <div
                      className="bottom_div"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "#2C8E14",
                        width: "100%",
                        height: "60px",
                        padding: "10px",
                      }}
                    >
                      <div>
                        <span onClick={toggleDrawer(anchor, false)}>
                          <button
                            onClick={() => {
                              dispatcher(list_StrategiesList({}));
                              dispatcher(
                                edit_Selectvalue({
                                  is_enabled: null, // Set the initial value here
                                  algo_id: null,
                                })
                              );
                              toggleDrawer(anchor, false);
                            }}
                            type="button"
                            style={{
                              width: "100px",
                              height: "40px",
                              color: "black",
                              marginRight: "20px",
                              backgroundColor: "white",
                              borderRadius: "5px",
                              fontFamily: "Roboto",
                              border: "1px solid #F2A618",
                            }}
                          >
                            Reset
                          </button>
                        </span>
                      </div>
                      <div>
                        <span onClick={toggleDrawer(anchor, false)}>
                          <button
                            type="submit"
                            onClick={() => {
                              toggleDrawer(anchor, false);
                            }}
                            style={{
                              width: "100px",
                              height: "40px",
                              color: "black",
                              background: !props.isValid
                                ? "linear-gradient(to right, #FFFA02,#F2A618 )"
                                : "linear-gradient(to right, #FFFA02,#F2A618 )",

                              borderRadius: "5px",
                              fontFamily: "Roboto",
                            }}
                          >
                            Save
                          </button>
                        </span>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
